import { useTheme } from '@organization/layout'
import { useSessionContext } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { deepMerge } from '@shared/utils'
import { ConfigProvider as BaseAntdConfigProvider } from 'antd'
import { PropsWithChildren } from 'react'

export const ConfigProvider = ({ children }: PropsWithChildren) => {
  const theme = useTheme()

  const { user } = useSessionContext()
  const { currentLang } = useLocales()

  return (
    <BaseAntdConfigProvider
      locale={currentLang?.systemValue}
      theme={deepMerge(user?.organization?.settings, theme)}
    >
      {children}
    </BaseAntdConfigProvider>
  )
}
